import { Button, Flex, Textarea, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useEvaluationCreateForm } from "@/hooks/useEvaluationCreateForm/useEvaluationCreateForm";
import { useEvaluationCreateFormInteractions } from "@/hooks/useEvaluationCreateFormActions/useEvaluationCreateFormActions";

import { SubmitButton } from "@/components/SubmitButton";

import { EvaluationFormFooterProps } from ".";
import { useTracking } from "./EvaluationCreateFormFooter.hooks";

export function EvaluationCreateFormFooter({
  onClickCancel,
  scoreCard,
  loading,
}: EvaluationFormFooterProps) {
  const { t } = useTranslation();
  const { form } = useEvaluationCreateForm();
  const { onClick } = useTracking();
  const { hasUnansweredQuestions, overallMaxScore, overallScore } =
    useEvaluationCreateFormInteractions();

  const handleOnClickTrack = () => {
    onClick(scoreCard);
  };

  return (
    <Flex flexDirection="column" gap="xxxs">
      <Flex p="s" flexDirection="column" gap="xs">
        <Flex justifyContent="space-between" alignItems="center">
          <Typography variant="headingBoldXS">
            {t("evaluation.overall_title")}
          </Typography>
          <Typography variant="bodyRegularS">
            {t("evaluation.overall_score", {
              score: overallScore,
              maxScore: overallMaxScore,
            })}
          </Typography>
        </Flex>
        <Flex flexDirection="column" gap="s">
          <form.Field name="feedback">
            {(field) => (
              <Textarea
                value={field.state.value}
                onChange={(event) => {
                  field.handleChange(event.target.value);
                }}
                placeholder={t("evaluation.add_feedback")}
              />
            )}
          </form.Field>
          <Flex gap="xxs" justifyContent="flex-end">
            <Button
              onClick={onClickCancel}
              variant="secondary"
              size="small"
              mode="ghost"
            >
              {t("cancel")}
            </Button>
            <SubmitButton
              onClick={handleOnClickTrack}
              type="submit"
              loading={loading}
              disabled={hasUnansweredQuestions > 0 || loading}
              size="small"
            >
              {t("publish")}
            </SubmitButton>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
